import { environment } from '../environments/environment';

let client;

function checkForClient(
  fnc: Function,
  name: string,
  descriptor: PropertyDescriptor
) {
  const method = descriptor.value;
  descriptor.value = function(...args) {
    if (client) { method.apply(this, args); } else {
      console.log('preview mode');
    }
  };
}

class GaWrapper {
  constructor(private clientTracker, embedID, embedName, utm, parent) {
    (window as any).ga(
      'create',
      environment.gaTrackerId,
      'auto',
      'idonate_embed'
    );
    if (this.clientTracker) {
      (window as any).ga(
        'create',
        this.clientTracker,
        'auto',
        'client_tracker',
        {'cookieFlags': 'SameSite=None; Secure'}
      );
    }
    (window as any).ga('idonate_embed.require', 'ecommerce');
    if (this.clientTracker) {
      (window as any).ga('client_tracker.require', 'ecommerce');
    }
    this.set('appVersion', 'app6');
    this.set('appId', embedID);
    this.set('appName', embedName);
    for (const key in utm) {
      this.set(`campaign${key}`, utm[key]);
    }
    for (const key in parent) {
      this.set(key, parent[key]);
    }
  }
  track(params) {
    (window as any).ga('idonate_embed.send', params);
    if (this.clientTracker) { (window as any).ga('client_tracker.send', params); }
  }

  trackEcommerce(params) {
    (window as any).ga('idonate_embed.ecommerce:addTransaction', params);
    (window as any).ga('idonate_embed.ecommerce:send');
    if (this.clientTracker) {
      (window as any).ga('client_tracker.ecommerce:addTransaction', params);
      (window as any).ga('client_tracker.ecommerce:send');
    }
  }
  set(key, val) {
    (window as any).ga('idonate_embed.set', key, val);
    if (this.clientTracker) { (window as any).ga('client_tracker.set', key, val); }
  }
}

export class GaClient {
  static trackSession(config) {
    (function(i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r;
      (i[r] =
        i[r] ||
        function() {
          (i[r].q = i[r].q || []).push(arguments);
        }),
        (i[r].l = 1 * (new Date() as any));
      (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(
      window,
      document,
      'script',
      'https://www.google-analytics.com/analytics.js',
      'ga'
    );
    client = new GaWrapper(
      config.properties.ga_tracker_id || null,
      config.id,
      config.name,
      {
        Content: config.properties.utm_content,
        Medium: config.properties.utm_medium,
        Name: config.properties.utm_campaign,
        Source: config.properties.utm_source,
        Keyword: config.properties.utm_term
      },
      {
        title: config.properties.parentName,
        hostname: config.properties.parentHostname,
        location: config.properties.hosted_url,
        referrer: config.properties.parentReferrer
      }
    );
  }
  @checkForClient
  static trackPageHit() {
    client.track('pageview');
  }
  @checkForClient
  static trackButtonClick(label: string, value?: number) {
    const obj = {
      hitType: 'event',
      eventCategory: 'Button',
      eventAction: 'Click',
      eventLabel: label
    };
    if (value) { obj['eventValue'] = value; }
    client.track(obj);
  }
  @checkForClient
  static sendTransaction(item: {}, organization: string, total: number) {
    if (!item['transaction'] || !item['transaction']['id']) { return; }
    const tranObj = {
      id: item['transaction']['id'],
      affiliation: organization,
      revenue: total || 0
    };
    client.trackEcommerce(tranObj);
  }
  @checkForClient
  static trackFieldAction(label: string, value?: number) {
    const obj = {
      hitType: 'event',
      eventCategory: 'Field',
      eventAction: 'Enter',
      eventLabel: label
    };
    if (value) { obj['eventValue'] = value; }
    client.track(obj);
  }
  @checkForClient
  static trackAlert() {
    client.track({
      hitType: 'event',
      eventCategory: 'Alert',
      eventAction: 'View',
      eventLabel: 'Error on transaction'
    });
  }
  @checkForClient
  static trackLinkClick(label) {
    client.track({
      hitType: 'event',
      eventCategory: 'Link',
      eventAction: 'Click',
      eventLabel: label
    });
  }
  @checkForClient
  static trackIconClick() {
    client.track({
      hitType: 'event',
      eventCategory: 'Icon',
      eventAction: 'Click',
      eventLabel: 'Close Multi-Designation'
    });
  }
  @checkForClient
  static trackSelection() {
    client.track({
      hitType: 'event',
      eventCategory: 'Select',
      eventAction: 'Select',
      eventLabel: 'Selected Corporate Match'
    });
  }
  @checkForClient
  static setVal(key, val) {
    client.set(key, val);
  }
}
